import Backbone from 'backbone'
import { API_PATH } from '../../config'
import {
  detailWithTitleHandler,
  selectMultiGoods,
} from '../../manager/view.handler'
import store from '../../store'
import { toJSONHelper } from '../../utils'
import { DecoFilterView } from './decoFilter.view'
import { DecorationCollection } from './decoration.collection'
import { GoodsCounterView } from './goodsCounter.view'

import tpl from './template/decoration.mustache'

export var DecorationView = Backbone.View.extend({
  tagName: 'div',
  className: 'DecorationView',
  collection: new DecorationCollection(),
  model: store.list,
  template: tpl,
  events: {
    'click [data-id]': selectMultiGoods,
    'click [data-detail-pop]': detailWithTitleHandler,
  },
  initialize: function () {
    this.collection.once('sync', this.render, this)
    this.collection.fetch()
  },
  // Method
  resetSelected: function () {
    var purchaseLimit = store.list.get('purchaseLimit')
    this.collection.resetSelectedGoods()
    $('[data-id]').attr('class', 'selected--false')

    // 5만원 이상일떄만 첫째 아이템 선택
    if (purchaseLimit > 50000) {
      $('.poker-mall-decoration__list:eq(0):visible')
        .find('ul>li:visible:eq(0)>a[data-id]')
        .trigger('click')
    }
  },
  render: function () {
    var $decoHead = $('<div class=poker-mall-decoration__head />')
    // decorationCategory = "deco" || "card"
    var decoList = this.collection.where({ decorationCategory: 'deco' })
    var cardList = this.collection.where({ decorationCategory: 'card' })

    var $decoBody = this.template.render({
      cardSection: cardList.length > 0,
      decoSection: decoList.length > 0,
      deco: toJSONHelper(decoList),
      card: toJSONHelper(cardList),
      API_PATH: API_PATH,
    })

    var goodsCounterView = new GoodsCounterView({
      collection: this.collection,
    })
    var decofilterView = new DecoFilterView({
      collection: this.collection,
      resetSelected: this.resetSelected,
    })

    $decoHead.append(decofilterView.render().$el, goodsCounterView.render().$el)

    this.$el.empty().append($decoHead, $decoBody)

    return this
  },
})
